module.exports = __webpack_public_path__ + "media/logos/youtube-logo-white-eb5575b9.svg";